import { render, staticRenderFns } from "./ManualEditButton.vue?vue&type=template&id=e061889e&scoped=true"
import script from "./ManualEditButton.vue?vue&type=script&lang=js"
export * from "./ManualEditButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e061889e",
  null
  
)

export default component.exports